import React, { useState, useEffect } from "react";
import classes from "../../style/HomeScreen.module.css";
import { useNavigate } from "react-router-dom";
import {
  ROUTE_DXTER_SCANNING
} from "../../Routes";
import { setLoginToken } from "../../Store/loginTokenSlice";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import { initOTPless } from "../../utils/initOtpless";
import { setOtpLessData, selectOtpLessData } from "../../Store/OtpLessData";
import { useDispatch, useSelector } from "react-redux";
import { selectPhoneNumber, setMobileNumber } from "../../Store/MobileSlice";
import CustomModal from "../../Components/CustomModal";

const ThirdSplash = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const OtpLessData = useSelector(selectOtpLessData);
  const phoneNumber = useSelector(selectPhoneNumber);
  const [showOTPlessPage, setShowOTPlessPage] = useState(true);

  // Loading state and API calls in progress
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpLessInitialized, setIsOtpLessInitialized] = useState(false);
  const [hasNavigated, setHasNavigated] = useState(false);

  useEffect(() => {
    const initializeOtpLess = async () => {
      setIsLoading(true); // Set loading to true when starting
      try {
        await initOTPless((otplessUser) => {
          console.log("OTPless User:", otplessUser);
          setIsOtpLessInitialized(true);

          callback(otplessUser);
        });
      } catch (error) {
        console.error("Error initializing OTPless:", error);
      } finally {
        setIsLoading(false); // Set loading to false once initialization completes
      }
    };

    initializeOtpLess();
  }, []);

  const callback = (otplessUser) => {
    if (hasNavigated) return;

    try {
      const otplessToken = otplessUser.token;
      dispatch(setOtpLessData(JSON.stringify(otplessUser)));

      const mobileMap = otplessUser.identities.find(
        (item) => item.identityType === "MOBILE"
      );
      let mobile = mobileMap?.identityValue;

      if (mobile.startsWith("91")) {
        mobile = mobile.substring(2);
      }
      dispatch(setLoginToken(otplessToken));
      dispatch(setMobileNumber(mobile));

      if (otplessToken) {
        if (!hasNavigated) {
          setHasNavigated(true);
          navigate(ROUTE_DXTER_SCANNING);
        }
      } else {
        console.error("Token is undefined, cannot navigate.");
      }
    } catch (error) {
      console.error("An error occurred before navigation:", error);
    }
  };

  const handleSubmit = async () => { };

  return (
    <div className={`${classes.BlurMainContainer}`}>
      <div className={classes.Splash3Main_Container}>
        <header className={classes.Splash1Header}>
          <img alt="" src={NewDexterLogo} className={classes.DexterLogo} />
        </header>
        <div className={classes.Internal_Main_Container3}>
          <p className={classes.Splash3SubHeading}>
            Relax and let Dexterr do your{" "}
            <span className={classes.Highlighting_text}>Investing</span> for
            you.
            <br />
            <span>
              This is the easiest Investing has ever <br /> been.
            </span>
          </p>
          <div className={classes.Spash3_Button_Container}>
            <button
              className={classes.Proceed_button}
              onClick={() => {
                handleSubmit();
              }}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>

      <CustomModal
        isOpen={showOTPlessPage}
        onClose={() => setShowOTPlessPage(false)}
      >
        <div id="otpless-login-page"></div>
      </CustomModal>

      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
    </div>
  );
};

export default ThirdSplash;
